import React, {createContext, useReducer} from 'react'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case 'SET_PROMOTE_CHANGES_DATA': {
      return { ...data, data: payload.data }
    }
    case 'SHOW_SELECT_FILES_POPUP': {
      return {
        ...data,
        show_select_files_popup: payload.data,
        selected_vehicle: payload?.selectedVehicle || {},
        selected_files: payload?.selectedFiles || {},
      }
    }
    case 'SET_PROMOTE_FILES_DATA': {
      return { ...data, promote_files_data: payload?.data }
    }
    default: {
      return { ...data }
    }
  }
}

const initialState = {
  data: {},
  selected_vehicle: {},
  selected_files: {},
  show_select_files_popup: false,
  promote_files_data: {},
}

const PromoteChangesStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <PromoteChangesContext.Provider value={[state, dispatch]}>
      {children}
    </PromoteChangesContext.Provider>
  )
}

export const PromoteChangesContext = createContext(initialState)
export const SET_PROMOTE_CHANGES_DATA = 'SET_PROMOTE_CHANGES_DATA'
export const SHOW_SELECT_FILES_POPUP = 'SHOW_SELECT_FILES_POPUP'
export const SET_PROMOTE_FILES_DATA = 'SET_PROMOTE_FILES_DATA'
export default PromoteChangesStore
